"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectSelector = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var utils_1 = require("../../utils");
var constants_1 = require("utils/constants");
var projectSelectorTimer;
var ProjectSelector = function (props) {
    var _a = React.useState(null), searchString = _a[0], setSearchString = _a[1];
    var _b = React.useState(false), focus = _b[0], setFocus = _b[1];
    var combinedProps = __assign(__assign({}, props), { searchString: searchString, setSearchString: setSearchString, focus: focus, setFocus: setFocus });
    return (React.createElement(sok_ui_1.Dropdown2, { className: 'project-selector', isOpen: focus, onChange: function (status, e) {
            var elem = e.target;
            while (elem) {
                if (elem.classList.contains('project-search-input')) {
                    return;
                }
                elem = elem.parentElement;
            }
            setFocus(status);
        } },
        React.createElement(sok_ui_1.TextInput, { className: 'project-search-input', value: searchString !== null
                ? searchString
                : props.value
                    ? props.value.name
                    : '', onFocus: function () {
                if (props.value) {
                    setSearchString(props.value.name);
                }
                setFocus(true);
            }, onBlur: function () {
                if (props.value !== null) {
                    setSearchString(props.value.name);
                }
            }, onChange: function (_a) {
                var value = _a.target.value;
                if (projectSelectorTimer) {
                    clearTimeout(projectSelectorTimer);
                }
                setSearchString(value);
                projectSelectorTimer = setTimeout(function () {
                    props.onChange(value);
                    projectSelectorTimer = undefined;
                }, constants_1.SEARCH_TIMEOUT);
            }, iconRight: React.createElement("span", { className: 'icons' },
                props.status === 'FETCHING' && (React.createElement("span", null,
                    React.createElement(sok_ui_1.Icon, { className: 'fa-spinner fa-spin' }))),
                props.value && (React.createElement(sok_ui_1.Icon, { className: 'fa-times', onClick: function () {
                        props.onSelect(null);
                        setSearchString(null);
                        props.onChange(null);
                    } })),
                React.createElement(sok_ui_1.Icon, { onClick: function () { return setFocus(!focus); }, className: 'fa-chevron-down' })) }),
        React.createElement(sok_ui_1.Dropdown2Menu, { className: 'activity-project-selector' }, (0, utils_1.renderDropdownMenu)(combinedProps))));
};
exports.ProjectSelector = ProjectSelector;
